import { isAxiosError } from "axios";

export class ApiError extends Error {
  protected status: number;

  constructor(obj: { message: string; status: number; [k: string]: unknown }) {
    super(obj.message);
    this.status = obj.status;
    this.name = "APIError";
  }

  public serializeError() {
    return {
      message: this.message,
      status: this.status,
    };
  }

  public static from(error: unknown) {
    if (isAxiosError(error)) {
      return new ApiError({
        message: "Something went wrong",
        ...error.response?.data,
      });
    }

    if (error instanceof Error) {
      return new ApiError({
        message: error.message,
        status: 500,
      });
    }

    return new ApiError({
      message: "Something went wrong",
      status: 500,
    });
  }
}
